import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  memberName, 
  isMultiple = false,
  count = 1 
}) => {
  if (!isOpen) return null;

  const title = isMultiple 
    ? `Excluir ${count} membros?` 
    : `Excluir membro?`;

  const message = isMultiple
    ? `Tem certeza de que deseja excluir ${count} membros selecionados? Esta ação não pode ser desfeita e removerá permanentemente todos os dados, incluindo informações de cadastro, contatos e histórico de filiação.`
    : `Tem certeza de que deseja excluir ${memberName}? Esta ação não pode ser desfeita e removerá permanentemente todos os dados, incluindo informações de cadastro, contatos e histórico de filiação.`;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg shadow-deep max-w-md w-full">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-12 h-12 bg-error/10 rounded-full flex items-center justify-center">
              <Icon name="AlertTriangle" size={24} className="text-error" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">{title}</h3>
              <p className="text-sm text-muted-foreground">Esta ação é irreversível</p>
            </div>
          </div>

          {/* Message */}
          <p className="text-sm text-foreground mb-6 leading-relaxed">
            {message}
          </p>

          {/* Warning Box */}
          <div className="bg-error/5 border border-error/20 rounded-md p-3 mb-6">
            <div className="flex items-start space-x-2">
              <Icon name="AlertCircle" size={16} className="text-error mt-0.5 flex-shrink-0" />
              <div className="text-sm">
                <p className="font-medium text-error mb-1">Atenção</p>
                <p className="text-error/80">
                  Membros excluídos não podem ser recuperados. Considere desativar se você precisar desses dados depois.
                </p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center justify-end space-x-3">
            <Button
              variant="outline"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              iconName="Trash2"
              iconPosition="left"
            >
              {isMultiple ? `Excluir ${count} membros` : 'Excluir membro'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;